import { CHUNK_LOAD_RELOAD_SESSION_KEY, isChunkLoadFailure } from '@/lib/chunk-load-errors';

/**
 * Filet de sécurité : rejets non interceptés par `lazy-route` (ex. préchargement CSS, autres loaders).
 * Après un chargement réussi de la page, on efface le drapeau pour permettre un nouveau reload auto au prochain déploiement.
 */
export function installChunkLoadRecovery(): void {
  if (typeof window === 'undefined') return;

  const reloadOnce = () => {
    const alreadyReloaded = window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_SESSION_KEY) === '1';
    if (alreadyReloaded) return;
    window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_SESSION_KEY, '1');
    window.location.reload();
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadFailure(event.reason)) {
      event.preventDefault();
      reloadOnce();
    }
  });

  window.addEventListener('error', (event) => {
    if (isChunkLoadFailure(event.error ?? event.message)) {
      reloadOnce();
    }
  });

  window.addEventListener('load', () => {
    window.setTimeout(() => {
      try {
        window.sessionStorage.removeItem(CHUNK_LOAD_RELOAD_SESSION_KEY);
      } catch {
        /* private mode, etc. */
      }
    }, 500);
  });
}
